import { Box } from '../../Box/Box.js';
import styled, { keyframes, css } from 'styled-components';

var progressing = /*#__PURE__*/keyframes({
  '0%': {
    transform: 'translateX(-100%)'
  },
  '100%': {
    transform: 'translateX(200%)'
  }
});
var LinearLoaderStyled = /*#__PURE__*/styled(Box).withConfig({
  displayName: "Linearstyled__LinearLoaderStyled",
  componentId: "sc-1fy4ytl-0"
})(function (props) {
  if (props.$percentage === undefined) {
    return {
      transform: 'translateX(-100%)',
      animationIterationCount: 'infinite',
      animationTimingFunction: 'linear',
      animationDuration: '1.5s',
      animationDelay: '1s'
    };
  }
  var translateXPercentage = -100 + props.$percentage;
  return {
    transition: 'transform 1s',
    transform: "translateX(".concat(props.$isRtl ? Math.abs(translateXPercentage) : translateXPercentage, "%)")
  };
}, css(["animation-name:", ";"], function (props) {
  return !props.$percentage && progressing;
}));

export { LinearLoaderStyled };
//# sourceMappingURL=Linear.styled.js.map
